import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyPage = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/getmypage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const changeInstaller = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/changeinstaller/' + params.id + '/' + params.installerId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchChangeInstaller = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/batchchangeinstaller/' + params.ids + '/' + params.installerId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const uploadSimInfosFile = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/uploadsiminfosfile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getmysiminfo = (params, urlParams) => {
  return axios.request({
    url: '/im/siminfo/getmysiminfo' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

